import { Empty, Spin, Tooltip } from 'antd'
import FolderPathArrow from 'components/icons/FolderPathArrow'
import NoInterview from 'components/icons/NoInterview.png'
import PlacementNoData from 'components/icons/PlacementNoData'
import React from 'react'
import {
  BatchHead,
  FolderDiv,
  FolderPathInner,
  FolderPathSpan,
  FolderSpinner,
  FolderWholeDiv,
  NoDataContent,
  NoDataStyle,
  TextBold,
} from '../style'

export default function FolderPath({
  handleRouteCheck,
  folderData,
  currentSearchParams,
  batchHistory,
  handleRecentRoute,
  GroupBy,
}) {
  return (
    <>
      {!!batchHistory?.length && currentSearchParams.size === 0 && (
        <>
          <BatchHead>Recently opened</BatchHead>
          <FolderDiv>
            {batchHistory.map((item, index) => (
              <FolderWholeDiv key={index + item?.degree}>
                <FolderPathInner onClick={() => handleRecentRoute(item?.route)}>
                  <FolderPathSpan>
                    <div>{item.yearOfPassing}</div>
                    <TextBold>
                      {item?.degreeShortForm !== ''
                        ? item?.degreeShortForm?.replaceAll('%20', ' ')
                        : item?.domain?.replaceAll('%20', ' ') ?? ''}
                    </TextBold>
                  </FolderPathSpan>
                </FolderPathInner>
                <TextBold>
                  {item.degree
                    ? item.dept
                      ? item?.degree?.replaceAll('%20', ' ') +
                        '  ' +
                        '(' +
                        item.dept?.replaceAll('%20', ' ') +
                        ')'
                      : item?.degree?.replaceAll('%20', ' ')
                    : item?.educationType
                    ? item?.educationType?.replaceAll('%20', ' ') + ' ' + 'Batches'
                    : ''}
                </TextBold>
              </FolderWholeDiv>
            ))}
          </FolderDiv>
        </>
      )}

      {currentSearchParams.size === 0 && folderData?.result?.length !== 0 && (
        <BatchHead>Batches</BatchHead>
      )}
      <FolderDiv>
        {folderData?.length !== 0 ? (
          folderData?.result?.length !== 0 ? (
            folderData?.result?.map((item, index) => {
              return (
                <FolderWholeDiv key={index + item?.id}>
                  <FolderPathInner
                    onClick={() =>
                      handleRouteCheck(
                        item?.name || item?.type,
                        folderData.nextGroupBy !== ''
                          ? folderData.nextGroupBy
                          : 'students',
                        item.id,
                        item?.shortForm ?? ''
                      )
                    }
                  >
                    <FolderPathSpan>
                      <Tooltip title={item?.type || item?.name}>
                        {item?.type
                          ? item?.type?.length > 15
                            ? `${item?.type?.slice(0, 15)}..`
                            : item.type
                          : item?.name && item?.name?.length > 15
                          ? `${item?.name?.slice(0, 15)}..`
                          : item?.name}
                      </Tooltip>
                      <FolderPathArrow />
                    </FolderPathSpan>
                  </FolderPathInner>
                </FolderWholeDiv>
              )
            })
          ) : (
            <NoDataStyle>
              {currentSearchParams.size === 0 ? (
                <Empty
                  image={NoInterview}
                  imageStyle={{ height: 500 }}
                  description={<span>No Data Available</span>}
                />
              ) : (
                <>
                  <PlacementNoData />
                  <NoDataContent>
                    Oh No! <br />
                    Try Another {GroupBy === 'stream' ? 'Department' : GroupBy}
                  </NoDataContent>
                </>
              )}
            </NoDataStyle>
          )
        ) : (
          <FolderSpinner>
            <Spin small tip="Loading" size="large" />
          </FolderSpinner>
        )}
      </FolderDiv>
    </>
  )
}
